<template>
  <div class="bienvenida-overlay" ref="container">
    <div class="bienvenida-card" ref="card">
      <h1 ref="titulo">Bienvenidos a la invitación de<br />Brenda Darani</h1>
      <button ref="boton" @click="ingresar">Ingresar</button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'Bienvenida-v',
  setup() {
    const titulo = ref(null);
    const boton = ref(null);
    const container = ref(null);

    const ingresar = () => {
      gsap.to([titulo.value, boton.value], {
        y: -50,
        opacity: 0,
        duration: 0.5,
        stagger: 0.2,
        onComplete: () => {
          gsap.to(container.value, {
            opacity: 0,
            duration: 0.5,
            onComplete: () => {
              container.value.style.display = 'none'; // ocultar completamente
            }
          });
        }
      });
    };

    onMounted(() => {
      gsap.from(container.value, { opacity: 0, duration: 1 });
      gsap.from(titulo.value, {
        y: -30,
        opacity: 0,
        duration: 1,
        delay: 0.3,
        ease: 'power2.out'
      });
      gsap.from(boton.value, {
        y: 30,
        opacity: 0,
        duration: 1,
        delay: 0.6,
        ease: 'power2.out'
      });
    });

    return {
      titulo,
      boton,
      container,
      ingresar
    };
  }
};
</script>

<style scoped>
.bienvenida-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bienvenida-card {
  text-align: center;
  padding: 40px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 30px;
}

button {
  background-color: #bdbdbd;
  color: white;
  font-size: 18px;
  border: none;
  padding: 10px 40px;
  border-radius: 30px;
  cursor: pointer;
  letter-spacing: 2px;
  transition: background 0.3s;
}

button:hover {
  background-color: #9e9e9e;
}
</style>
